import React from 'react';
import { gql } from '@apollo/client';
import { SignupStep2Controller, SignupStep2ControllerProps } from './SignupStep2.controller';
import { useRegisterMutation } from '../../../models/graphql';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';

gql`
  mutation Register($input: RegistrationInput!) {
    register(input: $input) {
      user {
        id
        organizations {
          id
          workspaces {
            id
          }
        }
      }
      token {
        ...CoreTokenFields
      }
    }
  }
`;

export type SignupStep2ApolloProps = Omit<SignupStep2ControllerProps, 'registerMutation' | 'signupError'> & {
  //
};

export const SignupStep2Apollo = (props: SignupStep2ApolloProps): JSX.Element => {
  const [registerMutation, { error: registerError, called: registerCalled }] = useRegisterMutation({
    fetchPolicy: 'no-cache'
  });

  let submitted = props.submitted;
  let signupError: string | JSX.Element = '';

  if (registerCalled && !registerError) {
    submitted = true;
  }
  if (registerError) {
    signupError = remapApolloErrors(registerError);
  }

  const controllerProps: SignupStep2ControllerProps = {
    ...props,
    registerMutation,
    submitted,
    signupError
  };

  return <SignupStep2Controller {...controllerProps} />;
};
